import React from "react";
import { Card } from "@/components/Primitives";
import { Badge } from "@/components/ui/badge";
import { money, OCC_COLORS } from "./common";
import { Building2, MapPin, TrendingUp, AlertCircle } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function PropertyCard({ property, currency, onOpen }) {
  const p = property;
  const equityPos = (p.estimated_equity || 0) >= 0;
  const cfPos = (p.monthly_cash_flow || 0) >= 0;
  return (
    <Card data-testid={`property-card-${p.id}`} onClick={() => onOpen(p)}
      className="cursor-pointer hover:-translate-y-0.5 transition-transform p-0 overflow-hidden">
      <div className="h-40 bg-[#F0E7D8] relative">
        {p.photo_document_id ? (
          <img src={`${BACKEND}/api/documents/${p.photo_document_id}/file`} alt={p.nickname}
            className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Building2 size={40} className="text-[#C6A45C]" strokeWidth={1.2} />
          </div>
        )}
        <div className="absolute top-3 right-3">
          <Badge style={{ background: `${OCC_COLORS[p.occupancy_status] || "#B79B86"}22`,
            color: OCC_COLORS[p.occupancy_status] || "#6b6256",
            borderColor: `${OCC_COLORS[p.occupancy_status] || "#B79B86"}55` }}>
            {p.occupancy_status}
          </Badge>
        </div>
      </div>
      <div className="p-5">
        <div className="font-display text-lg text-[#2C2A28] line-clamp-1">{p.nickname}</div>
        <div className="text-xs text-[#8A7F70] flex items-center gap-1 mt-1 line-clamp-1">
          <MapPin size={12} /> {p.address || "No address yet"}
        </div>
        <div className="grid grid-cols-2 gap-3 mt-4 text-sm">
          <div>
            <div className="text-[10px] uppercase tracking-[0.1em] text-[#A99F90]">Market value</div>
            <div className="font-mono-data text-[#2C2A28]">{money(p.estimated_market_value, currency)}</div>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.1em] text-[#A99F90]">Equity</div>
            <div className="font-mono-data" style={{ color: equityPos ? "#5a9a6a" : "#b06b6b" }}>{money(p.estimated_equity, currency)}</div>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.1em] text-[#A99F90]">Purchased</div>
            <div className="text-[#2C2A28] text-xs">{p.purchase_date || "—"}</div>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.1em] text-[#A99F90] flex items-center gap-1"><TrendingUp size={11} /> Monthly</div>
            <div className="font-mono-data" style={{ color: cfPos ? "#5a9a6a" : "#b06b6b" }}>{money(p.monthly_cash_flow, currency)}</div>
          </div>
        </div>
        {p.next_action && (
          <div data-testid="next-action" className="mt-4 flex items-center gap-2 text-xs text-[#8a6d2f] bg-[#C6A45C]/10 border border-[#C6A45C]/25 rounded-full px-3 py-1.5 w-fit">
            <AlertCircle size={13} /> {p.next_action.label}{p.next_action.date ? ` · ${p.next_action.date}` : ""}
          </div>
        )}
      </div>
    </Card>
  );
}
